import React from 'react';
import moment from 'moment';

import { MostProminentValue } from 'web-ui-components/lib/typography/values';
import { LogoDisplay } from 'web-ui-components/lib/transactions/logo';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { ProminentLabel } from 'web-ui-components/lib/typography/labels';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import config from '../../../config';

export function PaymentDetailComponent(props) {
  const { data, logoInitials, isFromReview = false } = props;
  const longDate = moment(data.dateRaw).format(config.dateFormatTimeline);

  return (
    <div
      className={
        isFromReview
          ? 'transaction-details-component'
          : 'enriched-transaction-details__info-wrapper payment-summary grey-box'
      }
    >
      <div
        className={
          isFromReview
            ? 'transaction-details-component__first-section'
            : 'enriched-transaction-details__info-wrapper__first-section'
        }
      >
        <LogoDisplay
          data-test-id="logo-display"
          imageSource={data.logo?.url}
          initials={logoInitials}
          alt={data.logo?.altTextTag}
          isSquare={!!data.logo?.url}
        />
        <div>
          <div
            className={
              isFromReview
                ? 'transaction-details-component__first-section__pending'
                : 'enriched-transaction-details__info-wrapper__first-section__pending'
            }
          >
            <ProminentLabel
              data-test-id="description"
              icon={
                data.posted === false && (
                  <Icon iconType="PendingFilledLarge" size="md" />
                )
              }
            >
              <strong>{data.description}</strong>
            </ProminentLabel>
          </div>
          <StandardBody data-test-id="date" isFlush>
            <span>{longDate}</span>
          </StandardBody>
        </div>
      </div>
      <div
        className={
          isFromReview
            ? 'transaction-details-component__second-section'
            : 'enriched-transaction-details__info-wrapper__second-section'
        }
      >
        <MostProminentValue data-test-id="transaction-amount" isFlush>
          {data.amount}
        </MostProminentValue>
        <StandardBody data-test-id="transaction-type" isFlush>
          <span>{data.type}</span>
        </StandardBody>
      </div>
    </div>
  );
}

PaymentDetailComponent.propTypes = {};
